import shipping from "./shipping";
import shippingTypes from "./shipping/types";
import navbarTypes from "./navbar/types";

// Redux state is in-memory only, so the open request and the selected main
// menu are mirrored to sessionStorage to survive a browser refresh.
const ACTIVE_REQUEST_KEY = "grsmActiveRequest";
const NAV_KEY_STORAGE = "grsmNavKey";

const REQUEST_PAGE_PATHS = [
  "/shipping",
  "/material",
  "/invoice",
  "/reviewerList",
  "/comments",
  "/newShippingComments",
  "/reports",
  "/shipmentdocumentation",
  "/processingdocumentation",
  "/requestByDelegate/edit",
  "/regulatoryReviewer/edit",
  "/shippingRequests/edit",
];

const PERSIST_ON = [
  shippingTypes.SHIPPING_REQUEST_DETAILS,
  shippingTypes.GET_SHIPPING_ACTION_TYPE,
  shippingTypes.REDIRECT_ACTION,
];

export const isRequestPagePath = (pathname) =>
  REQUEST_PAGE_PATHS.includes(pathname);

export const getActiveRequest = () => {
  try {
    return JSON.parse(sessionStorage.getItem(ACTIVE_REQUEST_KEY));
  } catch (e) {
    return null;
  }
};

export const getStoredNavKey = () => sessionStorage.getItem(NAV_KEY_STORAGE);

export const activeRequestMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  const type = action?.type;

  if (type === shippingTypes.CLEAR_SHIPPING_REQUEST) {
    sessionStorage.removeItem(ACTIVE_REQUEST_KEY);
  } else if (type === navbarTypes.SET_NAV_KEY && action.payload) {
    sessionStorage.setItem(NAV_KEY_STORAGE, action.payload);
  } else if (PERSIST_ON.includes(type)) {
    const state = store.getState()[shipping.name];
    const id = state.shippingRequestDetails?.[0]?.id;
    if (id) {
      sessionStorage.setItem(
        ACTIVE_REQUEST_KEY,
        JSON.stringify({
          id,
          shippingActionType: state.shippingActionType,
          redirectTo: state.redirectTo,
        })
      );
    }
  }

  return result;
};

export const restoreActiveRequest = (store) => {
  if (!isRequestPagePath(window.location.pathname)) return;

  const saved = getActiveRequest();
  if (!saved?.id) return;

  const row = { id: saved.id };
  const { actions } = shipping;
  if (saved.redirectTo) store.dispatch(actions.redirectAction(saved.redirectTo));
  if (saved.shippingActionType) {
    store.dispatch(actions.getShippingActionType(saved.shippingActionType));
  }
  store.dispatch(actions.getShippingRequestDetails(row));
  store.dispatch(actions.getDeputyShippingDetails(row));
  store.dispatch(actions.getMaterialShippingDetails(row));
  store.dispatch(actions.getShippingAttachment(row));
  store.dispatch(actions.getShipperDetails(row));
};
